import type { ComponentType } from '@grafikr/components';

const Component: ComponentType = (node) => {
  let cursorValidator = 0;
  const FISHERMAN_MODE_CODE = [70, 73, 83, 72, 69, 82, 77, 65, 78, 77, 79, 68, 69];
  node.addEventListener('keydown', (e) => {
    cursorValidator = e.keyCode === FISHERMAN_MODE_CODE[cursorValidator] ? cursorValidator + 1 : 0;
    if (cursorValidator === FISHERMAN_MODE_CODE.length) node.classList.add('fisherman-mode');
  });
};

export default Component;
